import { createSlice } from '@reduxjs/toolkit'

export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState: {
    loading: false,
    alert: {
      on: false,
      message: ""
    },
    warning: {
      on: false,
      title: "",
      message: "",
      actionTitle: "",
      onConfirm: undefined
    }
  },
  reducers: {
    setLoading: (state, action) => {
      return {
        ...state,
        loading: action.payload
      }
    },
    setAlert: (state, action) => {
      return {
        ...state,
        alert: action.payload
      }
    },
    showAlert: (state, action) => {
      return {
        ...state,
        alert: {
          on: true,
          message: action.payload
        }
      }
    },
    setWarning: (state, action) => {
      return {
        ...state,
        warning: action.payload
      }
    },
    closeWarning: (state, action) => {
      return {
        ...state,
        warning: {
          ...state.warning,
          on: false,
          onConfirm: undefined
        }
      }
    },
  }
})

// Action creators are generated for each case reducer function
export const { setLoading, setAlert, showAlert, setWarning, closeWarning } = feedbackSlice.actions

export default feedbackSlice.reducer